module.exports = __webpack_public_path__ + "fonts/LG_Smart_UI-Light.8bd2847.woff";